import { useMemo, useRef, useState } from 'react';
import { useLocation } from 'react-router';

import { FilterableColumn } from '../../types';
import { getObjectFiltersForBizAdmin } from '../../utils/get-object-filters-for-biz-admin';
import { ListViewActionsProps } from './list-view-actions.model';
import ListViewActionsView from './list-view-actions.view';

interface ListViewActionsControllerProps extends ListViewActionsProps {}

const ListViewActionsController = (
  props: ListViewActionsControllerProps
): JSX.Element => {
  const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false);
  const path = useLocation();

  const filterableColumns = useRef<FilterableColumn[] | undefined>(
    props.viewMetadata.viewDto.view?.[0]?.filterableColumns
  ).current;
  const areThereAnyFilterableColumns = useRef(
    !!filterableColumns?.length && filterableColumns.length > 0
  ).current;

  // Compute objectFilters for biz_admin__a module
  const objectFilters = useMemo(() => {
    const currentModule = path?.pathname?.split('/')?.[2];
    const filterViews = props.viewMetadata?.viewDto?.view?.[0]?.filterViews;
    return getObjectFiltersForBizAdmin(currentModule, filterViews);
  }, [path?.pathname, props.viewMetadata?.viewDto?.view]);

  const openFilterPanel = () => {
    setIsFilterPanelOpen(true);
  };

  const closeFilterPanel = () => {
    setIsFilterPanelOpen(false);
  };

  const toggleFilterPanel = () => {
    setIsFilterPanelOpen((prev) => !prev);
  };

  return (
    <ListViewActionsView
      isFilterPanelOpen={isFilterPanelOpen}
      openFilterPanel={openFilterPanel}
      closeFilterPanel={closeFilterPanel}
      toggleFilterPanel={toggleFilterPanel}
      filterableColumns={filterableColumns}
      areThereAnyFilterableColumns={areThereAnyFilterableColumns}
      objectFilters={objectFilters}
      {...props}
    />
  );
};

export default ListViewActionsController;
